module.exports = __webpack_public_path__ + "static/img/6areaA_6.9ac268b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/6areaA_6.png
// module id = 1050
// module chunks = 1